import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import SliderWrapper from "jd-library/SliderWrapper";
import SliderHeader from "jd-library/SliderHeader";
import historyHandler from "jd-library/historyHandler";
import SearchText from 'jd-library/SearchText';
import withRipple from 'jd-library/withRipple';
import toastMessageActions from 'jd-library/toastMessageActions';
import axios from 'axios';
import style from "./brand_manuf_slider.scss";
const BrandManufSlider = props => {
    const { onHidden, onSelect, type, value='' } = props;
    const [searchLoader, setSearchLoader] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const[debounceTimeout, setDebTimeout] = useState('');
    const[searchVal, setSearchVal] = useState('');
    useEffect(() => {
        if(value) {
            autoSuggestApi(value);
            // setSearchVal(value);
        }
    }, []);
    const sliderProps = {
        slider: {
            className: style['brand-manuf-slider']
        },
        onHidden: onHidden
    };
    const dataObj = (type == 'brand' ? 
        {
            url: '/marketplace/products/services/getBrandWithProductCount.service',
            createNewLabel: 'CREATE NEW BRAND',
            addNewToast: 'New Brand Added',
            heading: 'Brand',
            placeholder: 'Enter Brand Name'
        }: {
            url: '/marketplace/products/services/getManufacturerWithProductCount.service',
            createNewLabel: 'CREATE NEW MANUFACTURER',
            addNewToast: 'New Manufacturer Added',
            heading: 'Manufacturer',
            placeholder: 'Enter Manufacturer Name'
        }
    );
    const leftIconArr = [{
        className: 'icon-HDRback',
        onClick: () => {
            historyHandler.closeCurrent();
        }
    }];
    const rightIconArr = [{
        className: 'icon-HDRcross',
        onClick: () => {
            historyHandler.closeAll();
        }
    }];

    const autoSuggestApi = (value) => {
        var url = dataObj.url+'?searchKeywords='+value;
        const timeOutId = setTimeout(() => {
            axios.get(url).then(res => {
                var list = res.data;
                setSuggestions(list.data);
                setSearchVal(value);
                setSearchLoader(false);
            }).catch(e=>{
                setSearchVal(value);
                setSearchLoader(false);
                setSuggestions([])
            })
        }, 300)
        setDebTimeout(timeOutId);
    }

    const onInputChange = (e) => {
        setSearchLoader(true);
        if(debounceTimeout){
            clearTimeout(debounceTimeout);
        }
        autoSuggestApi(e.target.value);
        // setSearchVal(e.target.value);
    }
    const onClearHandle = () => {
        setSearchVal('');
        setSuggestions([]);
    }
    const headerProps = {
        heading: dataObj.heading,
        leftIcons: leftIconArr,
        rightIcons: rightIconArr,
        searchBox: true,
        searchVariant: 'edit',
        inputProps: {
            val: searchVal,
            placeholder: dataObj.placeholder,
            onChange: onInputChange,
            onClear: () => onClearHandle(),
            isSearchLoading: searchLoader,
        }
    };
    const onItemSelect = (ele) => {
        onSelect(ele.name);
        historyHandler.closeCurrent();
        if(ele.createNew){
            props.showToastMessage({
                message: dataObj.addNewToast,
                type: 'info'
            });
        }
    }
    const CreateNew = withRipple((props) => {
        const ele = {
            name: searchVal,
            createNew: true
        };
        return (
            <div className={`${style["item-list"]} ${style["create-new"]} ${props.rippleClass}`} {...props.rippleHandler} onClick={() => onItemSelect(ele)}>
                <div className={`${style["left-icon"]} ${style["round-border"]}`}>
                    <span className="icon-plus"></span>
                </div>
                <div className={style["right-side"]}>
                    <div className={style["item-name"]}>
                        <SearchText 
                            text={ele.name}
                            search={searchVal}
                            highlightClass={style['font400']}
                        />
                    </div>
                    <div className={style["create-new-label"]}>{dataObj.createNewLabel}</div>
                </div>
                {props.renderRipple()}
            </div>
        )
    });
    const ItemList = withRipple((props) => {
        const {ele} = props;
        return (
            <div className={`${style["item-list"]} ${props.rippleClass}`} {...props.rippleHandler} onClick={() => onItemSelect(ele)}>
                <div className="left-icon">
                    <span className="icon-HDRsearch"></span>
                </div>
                <div className={style["right-side"]}>
                    <div className={style["item-name"]}>
                        <SearchText 
                            text={ele.name}
                            search={searchVal}
                            highlightClass='font400'
                        />
                    </div>
                </div>
                {props.renderRipple()}
            </div>
        )
    });
    return (
        <SliderWrapper {...sliderProps} >
            <SliderHeader {...headerProps} />
            {searchVal ? 
                <>
                    {(suggestions && !suggestions.length) ? <CreateNew /> : null}
                    {suggestions.map((ele, index) => (
                        <ItemList key={'brandmanusld'+index} ele={ele} />
                    ))}
                </> : 
                null
            }
        </SliderWrapper>
    );
}
export default connect(null, {
    showToastMessage: toastMessageActions.showMessage
})(BrandManufSlider)